module.exports = __webpack_public_path__ + "img/banner-TV-1__sm.4e06bc0f.jpg";